exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".addedCard{background-color:#c18d6b}", ""]);

// exports
